/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { NormalizedSavedView } from "@/types/saved-views";

export interface SavedViewRecord<TFilters = Record<string, unknown>> {
  view_id: string;
  name: string;
  view_type: string;
  filters: TFilters;
  is_org_preset?: boolean | null;
  is_default?: boolean | null;
  created_at: string;
  updated_at: string;
}

export interface SavedViewsResponseLike<TFilters = Record<string, unknown>> {
  personal?: SavedViewRecord<TFilters>[];
  orgPresets?: SavedViewRecord<TFilters>[];
}

export function normalizeSavedViewsResponse<TFilters = Record<string, unknown>>(
  response: SavedViewsResponseLike<TFilters> | undefined,
  platformPresets: NormalizedSavedView<TFilters>[],
): NormalizedSavedView<TFilters>[] {
  const normalized: NormalizedSavedView<TFilters>[] = [];

  platformPresets.forEach((preset) => {
    normalized.push(preset);
  });

  if (response?.personal) {
    response.personal.forEach((view) => {
      normalized.push({
        id: view.view_id,
        name: view.name,
        view_type: view.view_type,
        filters: (view.filters as TFilters) || ({} as TFilters),
        is_org_preset: view.is_org_preset ?? false,
        is_default: view.is_default ?? false,
        created_at: view.created_at,
        updated_at: view.updated_at,
      });
    });
  }

  if (response?.orgPresets) {
    response.orgPresets.forEach((view) => {
      normalized.push({
        id: view.view_id,
        name: view.name,
        view_type: view.view_type,
        filters: (view.filters as TFilters) || ({} as TFilters),
        is_org_preset: view.is_org_preset ?? false,
        is_default: view.is_default ?? false,
        created_at: view.created_at,
        updated_at: view.updated_at,
      });
    });
  }

  return normalized;
}
